import React, { useState } from "react";
import Swal from "sweetalert2";
import { crearSesion } from "../../utils/Datos";
import { ahora, hoy } from "../../utils/Util";

export const CrearSesion = ({ procesoActivo, setActualizar }) => {
  const [cargando, setCargando] = useState(false);

  const handleCrearSesion = () => {
    setCargando(true);
    const $ = window.jQuery;
    crearSesion(procesoActivo.id_process).then((respuesta) => {
      console.log('respuesta sesión',respuesta);
      if (respuesta.status === true) {
        $("#modal").modal("hide");
        Swal.fire({
          title: "Listo",
          text: "Sesión iniciada",
          icon: "success",
          confirmButtonText: "Ok",
        });
        setActualizar(true);
      } else {
        Swal.fire({
          title: "Error",
          text: "Ocurrió un error al iniciar la sesión",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
      setCargando(false);
    });
  };

  const fechaHoy = hoy();
  const hora = ahora();

  return (
    <div
      className="modal fade"
      id="modal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="modelTitleId"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title"> Crear Sesión</h5>
            <div
              className="btn btn-sm btn-icon btn-active-color-primary"
              data-bs-dismiss="modal"
            >
              <span className="svg-icon svg-icon-1 ">X</span>
            </div>
          </div>
          <div className="modal-body">
            <div className="row mb-8">
              <div className="col-lg-3 col-sm-12 ">
                <label className="form-label">Año del proceso</label>
                <input
                  className="form-control mb-5"
                  aria-label=""
                  disabled={true}
                  type="text"
                  defaultValue={procesoActivo.yearProcess}
                />
              </div>
              <div className="col-lg-9 col-sm-12 ">
                <label className="form-label">Nombre del proceso</label>
                <input
                  type="text"
                  className="form-control mb-5"
                  disabled={true}
                  defaultValue={procesoActivo.name}
                />
              </div>
            </div>

            <div className="row mb-8">
              <div className="col-lg-3 col-sm-12 ">
                <label className="form-label">Fecha de inicio</label>
                <input
                  className="form-control mb-5"
                  aria-label=""
                  disabled={true}
                  type="text"
                  defaultValue={fechaHoy}
                />
              </div>
              <div className="col-lg-3 col-sm-12 ">
                <label className="form-label">Hora de inicio</label>
                <input
                  type="text"
                  className="form-control mb-5"
                  disabled={true}
                  defaultValue={hora}
                />
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-primary"
              data-bs-dismiss="modal"
              disabled={cargando}
            >
              Cerrar
            </button>
            <button
              type="button"
              className="btn btn-primary"
              disabled={cargando}
              onClick={handleCrearSesion}
            >
              {cargando ? " Creando sesión..." : " Crear sesión"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
